import React from 'react';
import { ArrowUpRightIcon, BanknoteIcon, RouteIcon, TruckIcon } from 'lucide-react';
type Rate = {
  label: string;
  value: string;
  icon: React.ReactNode;
};
const rates: Rate[] = [{
  label: 'Подача + завантаження',
  value: 'від 1000 грн',
  icon: <TruckIcon className="h-4 w-4" data-id="element-49" data-mp="2g8c0xie4v5cs" />
}, {
  label: 'У межах міста',
  value: 'від 30 грн/км',
  icon: <RouteIcon className="h-4 w-4" data-id="element-50" data-mp="38zc6vyw0yj73" />
}, {
  label: 'За містом',
  value: 'від 25 грн/км',
  icon: <ArrowUpRightIcon className="h-4 w-4" data-id="element-51" data-mp="3409af2u41laq" />
}];
export function PricingPanel() {
  return <section aria-labelledby="rates-title" className="rounded-[22px] border border-slate-200 bg-[#f8faf8] p-5" data-id="element-52" data-mp="2z164zha7xd28">
      <div className="flex items-center justify-between" data-id="element-53" data-mp="2u2uwb9vnt8ll">
        <div data-id="element-54" data-mp="2u4fpow68mlhv">
          <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-emerald-700" data-id="element-55" data-mp="1nlrbwol4r5ce">
            Без прихованих доплат
          </p>
          <h2 id="rates-title" className="mt-1 text-[19px] font-bold tracking-[-0.03em] text-slate-950" data-id="element-56" data-mp="1im4zghd4lt4n">
            Чесні тарифи
          </h2>
        </div>
        <span className="flex h-10 w-10 items-center justify-center rounded-[14px] bg-emerald-100 text-emerald-800" data-id="element-57" data-mp="g8xeh0w9spmh">
          <BanknoteIcon className="h-5 w-5" aria-hidden="true" data-id="element-58" data-mp="1c6din6y75ur" />
        </span>
      </div>
      <dl className="mt-4 divide-y divide-slate-200" data-id="element-59" data-mp="6ahsfcc3o6ju">
        {rates.map(rate => <div key={rate.label} className="flex items-center gap-3 py-3 first:pt-0 last:pb-0" data-id="element-60" data-mp="3ooqwjk69295n">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-white text-slate-500 shadow-sm" aria-hidden="true" data-id="element-61" data-mp="3thtltg3zuwg1">
              {rate.icon}
            </span>
            <dt className="flex-1 text-[13px] font-medium text-slate-600" data-id="element-62" data-mp="35qwg4l2skvd8">
              {rate.label}
            </dt>
            <dd className="text-[13px] font-bold tabular-nums text-slate-950" data-id="element-63" data-mp="39t18zhlf1nyt">
              {rate.value}
            </dd>
          </div>)}
      </dl>
    </section>;
}